<template>
  <button
    class="hamburger-button"
    :class="{ open: isOpen }"
    @click="toggle"
    aria-label="Toggle menu"
  >
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
  </button>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'HamburgerButton',
  computed: {
    ...mapGetters('ui', ['isSidebarOpen']),
    isOpen() {
      return this.isSidebarOpen
    }
  },
  methods: {
    ...mapActions('ui', ['toggleSidebar']),
    toggle() {
      this.toggleSidebar()
    }
  }
}
</script>

<style scoped>
.hamburger-button {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  padding: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  gap: 5px;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.hamburger-button:hover {
  background: #f3f4f6;
}

.hamburger-line {
  display: block;
  width: 22px;
  height: 2px;
  background: #1f2937;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* Open state - transform to X */
.hamburger-button.open .hamburger-line:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.hamburger-button.open .hamburger-line:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}

.hamburger-button.open .hamburger-line:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* Show on tablet and mobile */
@media (max-width: 1024px) {
  .hamburger-button {
    display: flex;
  }
}
</style>
